import type { Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

import { FONT_STACK } from '../constants/fontface.constant';

export const MuiDrawer = (baseTheme: Theme): Partial<Components> => ({
  MuiDrawer: {
    styleOverrides: {
      paper: {
        backgroundColor: 'transparent',
        '& .MuiListItemText-root': {
          transform: 'translateY(10%)', //to vertically center align with the icon
          '& span': {
            fontFamily: FONT_STACK,
          },
        },
        '& .MuiListItem-root': {
          p: {
            color: baseTheme.palette.text.primary,
          },
          '&.Mui-selected': {
            background: 'transparent',
          },
        },
        '& .MuiListItem-button': {
          '&.Mui-selected': {
            p: {
              color: baseTheme.palette.brand.main,
            },
          },
          '&:hover': {
            backgroundColor: baseTheme.palette.brand.lighter,
            border: 'none',
          },
        },
      },
    },
  },
});
